import analyticsReducer from "@store/Store/Data/Analytics/AnalyticsReducer";
import ProductsReducer from "@store/Store/Data/Products/ProductsReducer";
import headerReducer from "@store/Store/Data/Header/HeaderReducer";
import { combineReducers } from "redux";

const dataReducers = {
    analytics: analyticsReducer,
    products: ProductsReducer,
    header: headerReducer,
};

export type DataReducers = typeof dataReducers;

const dataReducer = combineReducers(dataReducers as any);
export default dataReducer;
